import List from "@mui/material/List";
import { CustomListItem } from "./CustomListItem";
import { useEffect, useRef, useCallback } from "react";

export const MessagesList = ({ notifications, selectedItem, setSelectedItem, onLoadMore, hasMore }) => {
  const listRef = useRef(null);

  const handleScroll = useCallback(() => {
    if (listRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listRef.current;
      const isNearBottom = scrollHeight - (scrollTop + clientHeight) < 50;

      if (isNearBottom && hasMore) {
        onLoadMore();
      }
    }
  }, [hasMore, onLoadMore]);

  useEffect(() => {
    const listElement = listRef.current;
    if (listElement) {
      listElement.addEventListener("scroll", handleScroll);
      return () => {
        listElement.removeEventListener("scroll", handleScroll);
      };
    }
  }, [handleScroll]);

  return (
    <List className="list" ref={listRef} style={{ overflow: "auto" }}>
      {notifications.map((item) => {
        return (
          <CustomListItem
            key={item?.messageId}
            notification={item}
            isSelectedItem={selectedItem === item?.messageId}
            setSelectedItem={setSelectedItem}
          />
        );
      })}
    </List>

  );
};
